import { useContext } from 'react';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { Grid, Icon, LinearProgress } from '@mui/material';
import { useForm } from 'react-hook-form';
import { CustomPagination } from 'utils/functions';
import {
  dropBoolean,
  dropPensao,
  dropAvisoPrevio,
  dropTipoInscricao,
} from 'utils/drops';
import { useDialog } from 'components/Modals';
import { GridContext } from 'contexts/GridContext';
import InputMask from 'components/InputMask';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import Input from 'components/Input';
import Title from '../Components/Title';
import localeText from 'utils/localeText';
import moment from 'moment';

const Desligamento = ({ drops, loading, pessoal = {}, onSubmit, onDelete }) => {
  const { openDialog } = useDialog();
  const desligamentos = pessoal?.Desligamentos ?? [];

  const Modal = ({ item }) => {
    const defaultValues = {
      rotina: 'PessoalDesligamento',
      id: item?.id,
      pessoal_id: pessoal?.id,
      desligamento_id: item?.desligamento_id || null,
      dtdeslig: item?.dtdeslig || null,
      indpagtoapi: item?.indpagtoapi || null,
      dtprojfimapi: item?.dtprojfimapi || null,
      indcumprparc: item?.indcumprparc || null,
      qtdiasinterm: item?.qtdiasinterm || '',
      observacao: item?.observacao || '',
      pensalim: item?.pensalim || null,
      percalim: item?.percalim || '',
      vralim: item?.vralim || '',
      nrcertobito: item?.nrcertobito || '',
      nrproctrab: item?.nrproctrab || '',
      tpInscSuc: item?.tpInscSuc || null,
      cnpjsuc: item?.cnpjsuc || '',
      cpfsub: item?.cpfsub || '',
      dtnascsub: item?.dtnascsub || null,
      novocpf: item?.novocpf || '',
      idedmdev: item?.idedmdev || '',
    };
    const { postLoading } = useContext(GridContext);
    const { control, handleSubmit } = useForm({ defaultValues });

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Title title="Informações Principais de Desligamento" disableMargin />
        </Grid>
        <Grid item xs={12} sm={8}>
          <Dropdown
            control={control}
            name="desligamento_id"
            label="Tipo de Desligamento"
            options={drops?.Desligamento}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <InputMask
            type="date"
            name="dtdeslig"
            control={control}
            label="Data de Desligamento"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Dropdown
            control={control}
            name="indpagtoapi"
            options={dropBoolean}
            label="Aviso Prévio Indenizado"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <InputMask
            type="date"
            control={control}
            name="dtprojfimapi"
            label="Data Projetada de Término do Aviso Prévio"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Dropdown
            control={control}
            name="indcumprparc"
            options={dropAvisoPrevio}
            label="Cumprimento Parcial"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <InputMask
            control={control}
            name="qtdiasinterm"
            label="Quantidade de Dias de Trabalho Intermitente"
          />
        </Grid>
        <Grid item xs={12}>
          <Input
            rows={3}
            multiline
            name="observacao"
            control={control}
            label="Observação"
          />
        </Grid>
        <Grid item xs={12}>
          <Title title="Pensão Alimentícia" />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            name="pensalim"
            control={control}
            options={dropPensao}
            label="Pensão Alimentícia"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <InputMask name="percalim" control={control} label="Percentual" />
        </Grid>
        <Grid item xs={12} sm={4}>
          <InputMask name="vralim" control={control} label="Valor Fixo" />
        </Grid>
        <Grid item xs={12}>
          <Title title="Motivo Especial / Judicial" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Input
            control={control}
            name="nrcertobito"
            label="Nº do Certificado de Óbito"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Input
            control={control}
            name="nrproctrab"
            label="Nº do Processo Trabalhista"
          />
        </Grid>
        <Grid item xs={12}>
          <Title title="Sucessão / Substituição" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Dropdown
            name="tpInscSuc"
            control={control}
            options={dropTipoInscricao}
            label="Tipo de Inscrição do Sucessor"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputMask
            name="cnpj"
            control={control}
            label="CNPJ do Sucessor"
            mask="99.999.999/9999-99"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <InputMask
            name="cpfsub"
            control={control}
            mask="999.999.999-99"
            label="CPF do Dependente / Substituto"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <InputMask
            type="date"
            name="dtnascsub"
            control={control}
            label="Data de Nascimento do Dependente / Substituto"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <InputMask
            name="novocpf"
            control={control}
            mask="999.999.999-99"
            label="Novo CPF do Trabalhador"
          />
        </Grid>
        <Grid item xs={12}>
          <Title title="Integração Folha de Pagamento" />
        </Grid>
        <Grid item xs={12}>
          <Input
            name="idedmdev"
            control={control}
            label="Identificador do Demonstrativo de Verbas Rescisórias"
          />
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Button
            color="primary"
            loading={postLoading}
            variant="contained"
            onClick={handleSubmit(onSubmit)}
          >
            Salvar
          </Button>
        </Grid>
      </Grid>
    );
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Title
          title="Desligamentos"
          disableMargin
          rightButton={
            <Button
              color="primary"
              variant="outlined"
              onClick={() => openDialog(<Modal />, 'Adicionar Desligamento')}
            >
              Adicionar
            </Button>
          }
        />
      </Grid>
      <Grid item xs={12}>
        <DataGrid
          rows={desligamentos}
          columns={[
            {
              field: 'desligamento',
              headerName: 'Tipo',
              minWidth: 300,
              flex: 1,
              sortable: false,
            },
            {
              field: 'dtdeslig',
              headerName: 'Data de Desligamento',
              width: 200,
              sortable: false,
              valueGetter: ({ value }) =>
                value && moment(value).format('DD/MM/YYYY'),
            },
            {
              field: 'indpagtoapi',
              headerName: 'Aviso Prévio Indenizado',
              width: 200,
              sortable: false,
            },
            {
              field: 'dtprojfimapi',
              headerName: 'Data de Desligamento',
              width: 200,
              sortable: false,
              valueGetter: ({ value }) =>
                value && moment(value).format('DD/MM/YYYY'),
            },
            {
              field: 'pensalim',
              headerName: 'Pensão Alimentícia',
              width: 200,
              sortable: false,
            },
            {
              field: 'nrcertobito',
              headerName: 'Nº do Certificado de Óbito',
              minWidth: 200,
              sortable: false,
            },
            {
              field: 'nrproctrab',
              headerName: 'Nº do Processo Trabalhista',
              minWidth: 200,
              sortable: false,
            },
            {
              field: 'actions',
              headerName: 'Ações',
              type: 'actions',
              width: 100,
              getActions: ({ row }) => [
                <GridActionsCellItem
                  icon={<Icon>edit</Icon>}
                  label="Editar"
                  onClick={() =>
                    openDialog(<Modal item={row} />, 'Editar Desligamento')
                  }
                />,
                <GridActionsCellItem
                  icon={<Icon>delete</Icon>}
                  label="Excluir"
                  onClick={() =>
                    onDelete({ rotina: 'PessoalDesligamento', id: row?.id })
                  }
                />,
              ],
            },
          ]}
          autoHeight
          pagination
          pageSize={10}
          density="compact"
          loading={loading}
          disableColumnMenu
          showCellRightBorder
          showColumnRightBorder
          disableSelectionOnClick
          localeText={localeText}
          getRowHeight={() => 'auto'}
          components={{
            Pagination: CustomPagination,
            LoadingOverlay: LinearProgress,
          }}
        />
      </Grid>
    </Grid>
  );
};

export default Desligamento;
